function shipchn() {
  setTimeout(function () {
    $.getJSON("/cart.js", function (cart) {
      var result = cart.total_price;
      var qntot = cart.item_count;
      var sp = 9900 - result;
      //alert(qntot)
      if (qntot == 0) {
        $(".prog").val(result);
        $(".cart_ship").text(
          "Add items to your bag to receive free shipping."
        );
      } else {
        if (sp > 0) {
          $(".prog").val(result);
          $(".cart_ship").text(
            "You're " +
              Shopify.formatMoney(sp) +
              " away from free shipping!"
          );
        } else if (sp <= 0) {
          $(".prog").val(result);
          $(".cart_ship").text("Your bag qualifies for free shipping!");
        }
      }
      $(".pb").load(" .pb > *");
    });
    $(".custom-add-size-modal-wrap").attr("style", "");
    $(".adc_col").attr("style", "");
  }, 1000);
}
function changeswatch(e, k) {
  $(".varsel" + k).val(e.value);
}
function changedrop(m, n) {
  $(".varsw" + n).val(m.value);
}
function redi(p) {
  location.href = p;
}
function op(u) {
  nex = u.nextElementSibling;
  nex.style.display = "";
  u.style.display = "";
}
function clmod(d) {
  d.parentElement.style.display = "none";
  d.parentElement.previousElementSibling.style.display = "";
}

function openSizeModal(button) {
  event.stopPropagation();
  event.preventDefault();
  var modal = button.nextElementSibling;
  modal.style.display = 'block';
  modal.style.opacity = '1';
  modal.style.visibility = 'visible';
  button.style.display = 'none';
}

function closeSizeModal(closeButton) {
  event.stopPropagation();
  event.preventDefault();
  var modal = closeButton.parentElement;
  modal.style.display = 'none';
  modal.style.opacity = '0';
  modal.style.visibility = 'hidden';
  var quickAddButton = modal.previousElementSibling;
  quickAddButton.style.display = 'block';
}
function collectionchangeswatch(h, j,template) {
  var variant_id = j;
  console.log(variant_id);
  $(".custom-error").addClass("hidden");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: variant_id,
    },
    dataType: "json",
    success: function (data) {
      $.getJSON("/cart.js", function (data) {
        check_cart();
        // var carts = JSON.parse(response);
        if(template != 'cart'){
        document.dispatchEvent(new CustomEvent("cart:build"));
        $(".pb").load(" .pb > *");
        $("#cart_ship").load(" #cart_ship > *");
        $("#cart--count").load(" #cart--count > *");
        $("#CartDrawer").addClass("drawer--is-open");
        $(".appear-animation").css("opacity", 1);
        $(".appear-animation").css("transform", "translateY(0px)");
        }else{
          location.reload();
        }
      });
    },
    error: function (error) {
      $(".custom-error").removeClass("hidden");
      $(".custom-error").text(error.responseJSON.description);
    },
  });
}
$(".drawer__close-button").click(function () {
  $("#CartDrawer").removeClass("drawer--is-open");
});

function chnatc(r) {
  /* 
    $('.stck > option').each(function() {
      if($(this).text() == r){
      	$(this).attr('selected', true)
      }else{
      	$(this).attr('selected', false)
      }
});
*/
}

function selch(lk) {
  /*
	$('.stck  > option:selected').each(function() {
   		d =document.getElementsByClassName('sw')
        for(i=0;i<d.length;i++){
        
                 if(d[i].dataset.cusvr==$(this).text()){
                   d[i].setAttribute('checked','checked')
                 }else{
                 	d[i].removeAttribute('checked')
                 }
        }
      
     
});
*/
}

$(".sl_responsive").slick({
  arrow: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: true,
  prevArrow:
    '<span class="prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path></svg></span>',
  nextArrow:
    '<span class="next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path></svg></span>',

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: "unslick",
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
$(".sli").slick({
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:
    '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg></div>',
  nextArrow:
    '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg></div>',
});

if (screen.width < "480") {
  $(".gs").removeClass("sl_responsive");
}

//     $('.col_meta_wrap').slick({
// //       arrow: false,
//       slidesToShow: 6,
//       slidesToScroll: 1,
//       infinite: true,

//       responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 4,
//             slidesToScroll: 1

//           }
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 3,
//             slidesToScroll: 1
//           }
//         },
//         {
//           breakpoint: 480,
//           settings: {
//             slidesToShow: 4,
//             slidesToScroll: 3,
//             infinite:false,
//             centerMode: true,
//             centerPadding:"10px"
//           }
//         }
//         // You can unslick at a given breakpoint now by adding:
//         // settings: "unslick"
//         // instead of a settings object
//       ]
//     });
